import { render } from "./LogoutCognitoRedirect.vue?vue&type=template&id=9759c8f6"
import script from "./LogoutCognitoRedirect.vue?vue&type=script&lang=js"
export * from "./LogoutCognitoRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__